/**
 * Route paths in one place.
 *
 * Links, the router, the prerender list and the sitemap all read from here, so
 * a path is never spelled out twice and renaming one is a single edit.
 */
export const ROUTES = {
  home: '/',
  features: '/features',
  pricing: '/pricing',
  explore: '/explore',
  master: (slug: string) => `/master/${slug}`,
  masterPattern: '/master/:slug',

  auth: '/auth',
  /** Opened from the reset email, with ?token= and ?email= in the query. */
  resetPassword: '/reset-password',
  clientLogin: '/client/login',

  about: '/about',
  blog: '/blog',
  contact: '/contact',
  privacy: '/privacy',
  terms: '/terms',
  support: '/support',
  rules: '/rules',
  reviews: '/reviews',
  updates: '/updates',

  /** Comparison (bottom-of-funnel) pages, one per competitor. */
  vs: {
    dikidi: '/vs/dikidi',
    easyweek: '/vs/easyweek',
    treatwell: '/vs/treatwell',
    goldie: '/vs/goldie',
    bumpix: '/zamena-bumpix',
  },

  client: {
    root: '/client',
    bookings: '/client/bookings',
    favorites: '/client/favorites',
    profile: '/client/profile',
    settings: '/client/settings',
  },

  app: {
    root: '/app',
    onboarding: '/app/onboarding',
    calendar: '/app/calendar',
    notifications: '/app/notifications',
    team: '/app/team',
    /** Opened from an invitation link; the token is the invitation. */
    teamJoin: '/app/team/join/:token',
    teamJoinTo: (token: string) => `/app/team/join/${token}`,
    clients: '/app/clients',
    reviews: '/app/reviews',
    analytics: '/app/analytics',
    services: '/app/services',
    portfolio: '/app/portfolio',
    billing: '/app/billing',
    settings: '/app/settings',
    settingsProfile: '/app/settings/profile',
    settingsSchedule: '/app/settings/schedule',
    settingsNotifications: '/app/settings/notifications',
    settingsSubscription: '/app/settings/subscription',
    settingsPrivacy: '/app/settings/privacy',
  },
} as const;

/**
 * Public routes that are prerendered at build time and listed in the sitemap.
 * Authenticated areas are excluded — they carry no indexable content.
 */
export const PRERENDERED_ROUTES: readonly string[] = [
  ROUTES.home,
  ROUTES.features,
  ROUTES.pricing,
  ROUTES.explore,
  ROUTES.about,
  ROUTES.blog,
  ROUTES.contact,
  ROUTES.privacy,
  ROUTES.terms,
  ROUTES.support,
  ROUTES.rules,
  ROUTES.reviews,
  ROUTES.updates,
  ...Object.values(ROUTES.vs),
];
